import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FaStar } from "react-icons/fa";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css/navigation";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

export default function Testimonials() {
    const reviews = [
        {
            name: "Ahmed Khan",
            role: "Traveler",
            image: "https://randomuser.me/api/portraits/men/32.jpg",
            review:
                "Amazing experience! The booking was smooth and the hotel exceeded expectations. Highly recommended!",
        },
        {
            name: "Sara Ali",
            role: "Tourist",
            image: "https://randomuser.me/api/portraits/women/44.jpg",
            review:
                "Best travel platform I’ve used. Great deals and excellent customer support!",
        },
        {
            name: "John Smith",
            role: "Business Traveler",
            image: "https://randomuser.me/api/portraits/men/12.jpg",
            review:
                "Very professional service. I always find the best hotels here for my business trips.",
        },
        {
            name: "Ali Raza",
            role: "Explorer",
            image: "https://randomuser.me/api/portraits/men/55.jpg",
            review:
                "Super easy booking process and great hotel recommendations. Loved it!",
        },
    ];

    return (
        <section className="py-10 sm:py-12 md:py-16 lg:py-20 bg-gradient-to-b from-white to-orange-50/30">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">

                {/* Heading */}
                {/* Heading */}
                <div className="text-center mb-12">

                    <span className="inline-flex items-center px-4 py-2 rounded-full bg-orange-100 text-[#0F172A] text-sm font-semibold mb-4">
                        Guest Reviews
                    </span>

                    <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
                        What Our Guests Say
                    </h2>

                    <p className="text-slate-500 mt-3 max-w-2xl mx-auto">
                        Thousands of travelers trust us to find the best hotels and experiences across Dubai.
                    </p>

                </div>

                {/* Navigation Buttons */}
                <div className="flex justify-center gap-4 mb-10">

                    <button className="custom-prev w-12 h-12 rounded-full bg-white border border-orange-100 shadow-lg flex items-center justify-center hover:bg-[#0F172A] hover:text-white transition">
                        <FaArrowLeft />
                    </button>

                    <button className="custom-next w-12 h-12 rounded-full bg-white border border-orange-100 shadow-lg flex items-center justify-center hover:bg-[#0F172A] hover:text-white transition">
                        <FaArrowRight />
                    </button>

                </div>

                {/* Swiper */}
                <Swiper
                    modules={[Autoplay, Pagination, Navigation]}
                    spaceBetween={16}
                    slidesPerView={1}
                    loop={true}
                    loopFillGroupWithBlank={true}
                    navigation={{
                        nextEl: ".custom-next",
                        prevEl: ".custom-prev",
                    }}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }}
                    pagination={{ clickable: true }}
                    breakpoints={{
                        640: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                    }}
                >
                    {reviews.map((item, index) => (
                        <SwiperSlide key={index}>
                            <div className="bg-white rounded-[28px] border border-slate-100 shadow-lg hover:shadow-2xl transition-all duration-500 p-8 h-full flex flex-col">

                                {/* Quote */}
                                <div className="w-14 h-14 rounded-2xl bg-orange-100 text-[#0F172A] flex items-center justify-center text-2xl mb-6">
                                    "
                                </div>

                                {/* Stars */}
                                <div className="flex text-yellow-400 gap-1 mb-5">
                                    {[...Array(5)].map((_, i) => (
                                        <FaStar key={i} />
                                    ))}
                                </div>

                                {/* Review */}
                                <p className="text-slate-600 leading-relaxed flex-grow">
                                    {item.review}
                                </p>

                                {/* Divider */}
                                <div className="h-px bg-slate-100 my-6"></div>

                                {/* User */}
                                <div className="flex items-center gap-4">

                                    <img
                                        src={item.image}
                                        alt={item.name}
                                        className="w-14 h-14 rounded-full object-cover border-2 border-orange-100"
                                    />

                                    <div>
                                        <h4 className="font-bold text-slate-900">
                                            {item.name}
                                        </h4>

                                        <p className="text-sm text-slate-500">
                                            {item.role}
                                        </p>
                                    </div>

                                </div>

                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

            </div>
        </section>
    );
}